import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { DashboardPage } from './routes/Dashboard';
import { UsersPage } from './routes/Users';
import { RoomsPage } from './routes/Rooms';
import { RoomDetailPage } from './routes/RoomDetail';
import { EarningsPage } from './routes/Earnings';
import { PeekPage } from './routes/Peek';
import { AuditPage } from './routes/Audit';
import { TeamPage } from './routes/Team';
import { NotificationsPage } from './routes/Notifications';
import { AffiliatePage } from './routes/Affiliate';
import { AffiliatesAdminPage } from './routes/AffiliatesAdmin';

function PermRoute({ perm, children }: { perm: string; children: React.ReactNode }) {
  return <Require perm={perm}>{children}</Require>;
}

import { useEffect } from 'react';
import { getStoredUser, setUnauthorizedHandler, setToken, setStoredUser, type CrmPrincipal } from './lib/api';
import { Navigate as Nav } from 'react-router-dom';
import { PwaUpdatePrompt } from './components/PwaUpdatePrompt';

function Require({ perm, children }: { perm: string; children: React.ReactNode }) {
  const user = getStoredUser();
  if (!user) return <Nav to="/login" replace />;
  if (!user.permissions.includes(perm)) {
    return (
      <div className="glass rounded-2xl p-6 text-sm text-stone-300 max-w-md">
        Доступ запрещён. Требуется право <code className="text-amber-300">{perm}</code>.
      </div>
    );
  }
  return <>{children}</>;
}

export default function App() {
  useEffect(() => {
    setUnauthorizedHandler(() => {
      setToken(null);
      setStoredUser(null);
      window.location.assign('/login');
    });
  }, []);

  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginRedirect />} />
        <Route element={<AppShell />}>
          <Route index element={<DashboardPage />} />
          <Route path="/users" element={<PermRoute perm="users:view"><UsersPage /></PermRoute>} />
          <Route path="/rooms" element={<PermRoute perm="rooms:view"><RoomsPage /></PermRoute>} />
          <Route path="/rooms/:id" element={<PermRoute perm="rooms:view"><RoomDetailPage /></PermRoute>} />
          <Route path="/earnings" element={<PermRoute perm="rake:view"><EarningsPage /></PermRoute>} />
          <Route path="/peek" element={<PermRoute perm="rooms:peek"><PeekPage /></PermRoute>} />
          <Route path="/audit" element={<PermRoute perm="audit:view"><AuditPage /></PermRoute>} />
          <Route path="/notifications" element={<PermRoute perm="audit:view"><NotificationsPage /></PermRoute>} />
          <Route path="/team" element={<PermRoute perm="settings:edit"><TeamPage /></PermRoute>} />
          <Route path="/affiliate" element={<PermRoute perm="affiliate:view"><AffiliatePage /></PermRoute>} />
          <Route path="/affiliates-admin" element={<PermRoute perm="affiliate:manage"><AffiliatesAdminPage /></PermRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
      <PwaUpdatePrompt />
    </>
  );
}

function LoginRedirect() {
  const u: CrmPrincipal | null = getStoredUser();
  // Аффилиат сразу идёт в свой раздел, чтобы не видеть пустую Dashboard.
  if (u?.role === 'affiliate') return <Navigate to="/affiliate" replace />;
  if (u) return <Navigate to="/" replace />;
  return <AppShell />;
}
